import { createAction } from 'redux-api-middleware';
import { contractSchema } from './schemas';
import { handleError, handleResponse } from '../utils';

export const POST_CALCULATION_FEATURE_REQUEST = 'POST_CALCULATION_FEATURE_REQUEST';
export const POST_CALCULATION_FEATURE_SUCCESS = 'POST_CALCULATION_FEATURE_SUCCESS';
export const POST_CALCULATION_FEATURE_FAILURE = 'POST_CALCULATION_FEATURE_FAILURE';

export const PATCH_CALCULATION_FEATURE_REQUEST = 'PATCH_CALCULATION_FEATURE_REQUEST';
export const PATCH_CALCULATION_FEATURE_SUCCESS = 'PATCH_CALCULATION_FEATURE_SUCCESS';
export const PATCH_CALCULATION_FEATURE_FAILURE = 'PATCH_CALCULATION_FEATURE_FAILURE';

export const postCalculationFeature = (contractAddress, calculationFeature) =>
  createAction({
    endpoint: `${window.config.apiUrl}/contracts/${contractAddress}/calc-features`,
    method: 'POST',
    body: JSON.stringify(calculationFeature),
    types: [
      POST_CALCULATION_FEATURE_REQUEST,
      {
        type: POST_CALCULATION_FEATURE_SUCCESS,
        payload: (action, state, res) => handleResponse(contractSchema, action, state, res),
      },
      { type: POST_CALCULATION_FEATURE_FAILURE, payload: handleError },
    ],
  });

export const patchCalculationFeature = (contractAddress, calculationFeature) =>
  createAction({
    endpoint: `${window.config.apiUrl}/contracts/${contractAddress}/calc-features/${calculationFeature.address}`,
    method: 'PATCH',
    body: JSON.stringify(calculationFeature),
    types: [
      PATCH_CALCULATION_FEATURE_REQUEST,
      {
        type: PATCH_CALCULATION_FEATURE_SUCCESS,
        payload: (action, state, res) => handleResponse(contractSchema, action, state, res),
      },
      { type: PATCH_CALCULATION_FEATURE_FAILURE, payload: handleError },
    ],
  });
